import { makeAutoObservable, runInAction } from "mobx";
import { baseApiUrl } from "../api/constants";
export default class UserStore {
  user: any = null;
  token: string | null = null;
 
  constructor() {
    makeAutoObservable(this);
  }
 
  get isLoggedIn() {
    return !!this.user;
  }
 
  setUser = (user: any, token: string) => {
    this.user = user;
    this.token = token;
    localStorage.setItem("token", token);
  };
 
  logout = () => {
    this.user = null;
    this.token = null;
    localStorage.removeItem("token");
  };
 
  loading = true;
  loadUser = async () => {
    console.log("Running loadUser()");
    this.loading = true;
    const token = localStorage.getItem("token");
    console.log("Token in localStorage:", token);
    console.log("Token in localStorage:", token);
    if (!token) {
      this.loading = false;
      return;
    }

    try {
      const resData = await fetch(`${baseApiUrl}/auth/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
 
      const resJson = await resData.json();

      if (resJson.status == "success") {
        runInAction(() => {
          this.user = resJson.data;
          this.user = resJson.data;
          this.token = token;
        });
      } else {
        this.logout();
      }
    } catch (err) {
      console.error("Error in loadUser:", err);
      console.error("Error in loadUser:", err);
      this.logout();
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
 